// Scottish Gaelic translations
export const gd: Record<string, string> = {
  'menu.dashboard': 'Clàr-stiùiridh',
  'menu.customers': 'Luchd-ceannach',
  'menu.products': 'Bathar',
  'menu.users': 'Luchd-cleachdaidh',
  'menu.settings': 'Roghainnean',
  'menu.logout': 'Clàraich a-mach',
  'dashboard.title': 'Clàr-stiùiridh',
  'dashboard.newOrder': 'Òrdugh ùr',
  'order.title': 'Òrdugh ùr',
  'order.customer': 'Neach-ceannach',
  'order.products': 'Bathar',
  'order.total': 'Iomlan',
  'users.title': 'Luchd-cleachdaidh',
  'users.name': 'Ainm',
  'users.email': 'Post-d',
  'common.yes': 'Tha',
  'common.no': 'Chan eil',
  'common.cancel': 'Sguir dheth',
  'common.save': 'Sàbhail',
  'common.search': 'Lorg',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Clàraich a-steach',
  'login.welcome': 'Fàilte, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Post-d',
  'signup.phone': 'Fòn',
  'menu.reportsAndAccounting': 'Aithisgean & Cunntasachd',
  'menu.systemAndCommunication': 'Siostam & Conaltradh',
};